import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { theme } from './styles/theme';
import './styles/global.css';

// Configure React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: 10000,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing root element.');
}
const root = ReactDOM.createRoot(rootElement);

async function bootstrap() {
  const { loadRuntimeConfig } = await import('./config/runtimeConfig');
  await loadRuntimeConfig();

  const [{ configureAmplify }, { default: App }] = await Promise.all([
    import('./config/amplify'),
    import('./App'),
  ]);

  configureAmplify();

  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider theme={theme}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}

bootstrap().catch((error) => {
  console.error('Failed to bootstrap admin portal', error);
  root.render(
    <React.StrictMode>
      <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
        Failed to initialize admin portal configuration.
      </div>
    </React.StrictMode>
  );
});
